import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../service/user.service';
import { PlanthunterService } from '../../service/planthunter.service';
import { Planthunter } from '../../classes/planthunter';
import { ConfigurationHelper } from '../../helper/configuration.helper';
import { Product } from '../../classes/product';
import { ProductService } from '../../service/product.service';
import { LazyLoadDirective } from '../lazyload/ng-lazy-load.directive';
import { ProductItemGridComponent } from '../products/productitem.grid.component';
import { NgClass } from '@angular/common';

/**
 * Planthunter product grid overview with added load more button
 *
 * @author Patrick van Zadel
 */
@Component({
    selector: 'planthunter-overview-grid-component',
    templateUrl: './planthunter.overview.grid.component.html',
    styleUrls: ['planthunter.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        ProductItemGridComponent,
        LazyLoadDirective,
    ],
})
export class PlanthunterOverviewGridComponent implements OnInit {
    @Input() planthunter: Planthunter;
    @Input() showAllHunterProducts: string;
    @Output() viewProductDetailClickEvent = new EventEmitter();

    loading: boolean;
    planthunterDetailURL: string;
    planthunterProductList: Product[];
    showAllProducts: boolean;
    showAllProductsForHunter: string;
    allProductsFetched: boolean;

    constructor(
        private planthunterService: PlanthunterService,
        private productService: ProductService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.planthunterProductList = this.planthunter.products;

        if (
            this.showAllHunterProducts ===
                this.planthunter.planthunterFeature &&
            !this.isShowToggleMoreProduct()
        ) {
            this.toggleShowMorePlanthunterProducts(
                this.planthunter.planthunterFeature,
            );

            setTimeout(() => {
                this.gotoActivePlanthunter(this.planthunter.planthunterFeature);
            }, 500);
        }
    }

    toggleShowMorePlanthunterProducts(
        planthunterFeature: string,
        anchor: string = null,
    ) {
        if (this.showAllProducts) {
            this.gotoActivePlanthunter(planthunterFeature);
            this.showAllProducts = false;
            this.showAllProductsForHunter = planthunterFeature;
            return;
        }

        if (this.allProductsFetched) {
            this.showAllProducts = true;
            this.showAllProductsForHunter = planthunterFeature;
            return;
        }

        this.loading = true;
        this.getMorePlanthunterProducts(planthunterFeature);
    }

    getMorePlanthunterProducts(planthunterFeature: string) {
        this.planthunterService
            .getMorePlanthunterProducts(planthunterFeature)
            .then(products => {
                this.planthunterProductList = [
                    ...this.planthunterProductList,
                    ...products,
                ];
                this.showAllProducts = true;
                this.showAllProductsForHunter = planthunterFeature;
                this.allProductsFetched = true;
                this.loading = false;
            });
    }

    getShowAmountOfProducts() {
        return this.showAllProducts
            ? this.planthunterProductList.slice(0, 99)
            : this.planthunterProductList.slice(0, 4);
    }

    isShowToggleMoreProduct(): boolean {
        return this.planthunterProductList.length < 5;
    }

    /**
     * Method to trigger the scrolling to a product when navigating back from a detail page.
     * This will first get all the products for a hunter and only then scroll to the needed product.
     *
     * @param anchor
     * @param planthunterId
     */
    scrollToProductForPlanthunter(planthunterId: string) {
        this.gotoActivePlanthunter(planthunterId);
        this.toggleShowMorePlanthunterProducts(planthunterId);
    }

    gotoActivePlanthunter(planthunterId: string) {
        const planthunterElement = document.querySelector(
            '#ID' + planthunterId,
        );
        if (planthunterElement) {
            const planthunterBoundingRect =
                planthunterElement.getBoundingClientRect();
            const planthunterElementYPosition = planthunterBoundingRect.top;
            // Check if window.scrollY is available and use that. Otherwise fallback to pageYOfsset (for IE)
            const windowScrollY =
                window.scrollY === undefined
                    ? window.pageYOffset
                    : window.scrollY;

            window.scrollTo(0, planthunterElementYPosition + windowScrollY);
        }
    }

    viewProductDetail(detailUrl) {
        window.location.href = ConfigurationHelper.getWebshopUrl(
            detailUrl + ';origin=planthunter',
        );
    }

    isUserLoggedin(): boolean {
        return this.userService.isLoggedIn();
    }
}
